import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";
import { CacheService } from "../services/cache.service";

@Injectable({
  providedIn: "root",
})
export class SiteService {
  public _: any;

  constructor(
    public appConfig: AppConfig,
    public commonService: CommonService,
    public cacheService: CacheService
  ) {
    this._ = this.commonService.getLodash();
  }

  async getNotifyList() {
    let returnData = [];

    /* CHECK CACHE */
    /* let cacheName = "site/getNotifyList";
        let notifyList = this.cacheService.getData(cacheName, this.appConfig.cache.ttl.common);
        if (!this._.isEmpty(notifyList)) {
            return notifyList;
        } */

    let params = {
      url: this.appConfig.busAPIBaseURL + "site/getNotifyList",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {},
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData = returnedData.data;

      /* SAVE CACHE */
      /* this.cacheService.setData(cacheName, returnData); */
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async getFaqData() {
    let returnData = [];
    let params = {
      url: this.appConfig.busAPIBaseURL + "site/getFaqs",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {},
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData = returnedData.data;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  /* 取得できなかったときは null を返す（呼び出し元が既存の設定を保持できるようにするため） */
  async getBusSettings() {
    let returnData = null;
    let params = {
      url: this.appConfig.busAPIBaseURL + "site/getBusSettings",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {},
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData && returnedData.status == "success") {
      returnData = returnedData.data;
    } else {
      console.error(
        "getBusSettings failed",
        returnedData ? returnedData.message : null
      );
    }

    return returnData;
  }
}
